module.exports = __webpack_public_path__ + "img/patron saint of learning.1244ffe0.png";